var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 30,
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m19.54915,0.91078l0,21.98109l1.98014,0.01078l0,-10.46257l4.78407,0l0,-2.76919l-4.78407,0l0,-5.99092l6.22761,0l0,-2.76919l-8.20774,0zm11.78257,4.46087c0.71799,0 1.29238,-0.82968 1.29238,-1.84253s-0.58195,-1.84253 -1.29238,-1.84253c-0.71799,0 -1.29238,0.82968 -1.29238,1.84253s0.58195,1.84253 1.29238,1.84253zm-1.00518,2.76919l0,14.75104l1.98014,0l0,-14.75104l-1.98014,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fillRule: "evenodd",
    d: "m39.66039,7.70983c-2.63766,0 -4.4742,3.17864 -4.4742,6.9499s1.83654,6.9499 4.4742,6.9499c1.20924,0 2.19931,-0.66805 2.92486,-1.74556l0,1.95028c0,2.44594 -1.34528,4.48242 -3.10625,4.48242c-0.63485,0 -1.26215,-0.3448 -1.76096,-0.84045l-0.99763,2.45671c0.79357,0.7327 1.73829,1.15293 2.75103,1.15293c2.81149,0 5.08638,-3.24329 5.08638,-7.2516l0,-13.67353l-1.97258,0l0,1.31456c-0.72555,-1.0775 -1.71561,-1.74556 -2.92486,-1.74556zm-2.48651,6.9499c0,-2.33818 1.25459,-4.18072 2.70568,-4.18072s2.70568,1.84253 2.70568,4.18072s-1.25459,4.18072 -2.70568,4.18072s-2.70568,-1.84253 -2.70568,-4.18072z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    d: "m51.71504,10.47901c-1.17146,0 -2.12373,1.42231 -2.12373,3.09244l0,9.32041l-1.98014,0l0,-14.75104l1.98014,0l0,1.34688c0.58195,-1.06673 1.43598,-1.77788 2.55453,-1.77788c1.39063,0 2.45628,0.98053 3.07601,2.48904c0.68776,-1.45463 1.80631,-2.48904 3.15915,-2.48904c2.25977,0 3.66552,2.59679 3.67308,5.80775l0,9.37429l-1.98014,0l0,-9.33119c0,-1.67013 -0.95228,-3.09244 -2.12373,-3.09244s-2.12373,1.42231 -2.12373,3.09244l0,9.33119l-1.98014,0l0,-9.33119c-0.00756,-1.67013 -0.95984,-3.08166 -2.13129,-3.08166z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fillRule: "evenodd",
    d: "m72.61984,9.81096c-0.88426,-1.30378 -2.0935,-2.10113 -3.49169,-2.10113c-2.94753,0 -5.04859,3.56654 -5.04859,7.81191s2.0935,7.81191 5.04859,7.81191c1.39819,0 2.60743,-0.80813 3.49169,-2.10113l0,1.65936l1.98014,0l0,-14.75104l-1.98014,0l0,1.67013zm-6.55259,5.71077c0,-2.81229 1.51155,-5.04272 3.28007,-5.04272c1.76096,0 3.28007,2.21966 3.28007,5.04272c0,2.81229 -1.51155,5.04272 -3.28007,5.04272c-1.76852,-0.01078 -3.28007,-2.23043 -3.28007,-5.04272z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "none",
    d: "m2,0.91078l13.32436,0l0,28.48922l-13.32436,0l0,-28.48922z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#1abcfe",
    d: "m8.6584,15.15538c0,-2.61834 1.48888,-4.75179 3.33298,-4.75179c1.83654,0 3.33298,2.12268 3.33298,4.75179c0,2.61834 -1.48888,4.75179 -3.33298,4.75179c-1.83654,0 -3.33298,-2.13346 -3.33298,-4.75179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    fill: "#0acf83",
    d: "m2,24.6482c0,-2.61834 1.48888,-4.75179 3.33298,-4.75179l3.33298,0l0,4.75179c0,2.61834 -1.48888,4.75179 -3.33298,4.75179c-1.8441,0 -3.33298,-2.12268 -3.33298,-4.75179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    fill: "#ff7262",
    d: "m8.6584,0.91078l0,9.49281l3.33298,0c1.83654,0 3.33298,-2.12268 3.33298,-4.75179c0,-2.61834 -1.48888,-4.75179 -3.33298,-4.75179l-3.33298,0l0,0.01078z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    fill: "#f24e1e",
    d: "m2,5.66257c0,2.61834 1.48888,4.75179 3.33298,4.75179l3.33298,0l0,-9.50359l-3.33298,0c-1.8441,0 -3.33298,2.12268 -3.33298,4.75179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    fill: "#a259ff",
    d: "m2,15.15538c0,2.61834 1.48888,4.75179 3.33298,4.75179l3.33298,0l0,-9.50359l-3.33298,0c-1.8441,0 -3.33298,2.13346 -3.33298,4.75179z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.ba3a10e14c2b400c5981eb1cab9b1ffc.svg";
export { ForwardRef as ReactComponent };